/** @format */

//const urlService = "https://localhost:44355";
//const urlService = "https://localhost:5001";
const urlService =
    window.location.hostname.includes("localhost") ||
        window.location.hostname.includes("127.0.0.1")
        ? "https://localhost:44320"
        : window.location.hostname.includes("dev.propins.cl")
            ? "https://apidev.propins.cl"
            : "https://api.propins.cl";

export { urlService };
